export const getEnv: () => 'production' | 'development' = () => {
  const subDomain = window.location.host.split('.').shift()

  return subDomain === 'quick' ? 'production' : 'development'
}
